import React from 'react';
import {faShare, faCopy} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "./Modal";
import {Button} from "./Button";
import createLink from "../../libs/createLink";
import {canonical} from "../../libs/helper";


class ShareProfile extends React.Component {
    constructor(props){
        super(props);
        this.state  = {
            toggle : false,
            successCopy : false
        }
        this.copyTextToClipboard = this.copyTextToClipboard.bind(this);
    }

    async copyTextToClipboard(text = this.textUrl.value) {
        if ('clipboard' in navigator) {
            this.setState({successCopy : true});
            return await navigator.clipboard.writeText(text);
        } else {
            this.setState({successCopy : true});
            return document.execCommand('copy', true, text);
        }

    }


    render() {
        return this.props.user._id ? (
            <div className={"w-100"}>
                <div onClick={()=>{this.setState({toggle : true})}}>
                    {this.props.children ? this.props.children : <FontAwesomeIcon icon={faShare} /> }
                </div>
                <Modal toggle={this.state.toggle} handleClose={() => this.setState({toggle: false})}>
                    <div id={"share-profile"}>
                        <div className={"card card-modal"}>
                            <div className={"content"}>
                                <div className={"group-input"}>
                                    <input type={"text"} ref={(ref) => this.textUrl = ref} readOnly defaultValue={canonical(createLink("userProfile", this.props.user), "", "userProfil")} />
                                    <FontAwesomeIcon className={"cursor-pointer"} icon={faCopy} onClick={()=>this.copyTextToClipboard()} />
                                </div>
                                {this.state.successCopy ? <div className={"mt-4 text-success"}>L'adresse a bien été copiée</div> : null}
                            </div>
                            <div className={"footer"}>
                                <Button
                                    btnStyle={"cancel"}
                                    size={"small"}
                                    onClick={() => this.setState({toggle: false})}
                                    content={"Fermer"}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        ) : null
    }
};

ShareProfile.defaultProps = {
    user: {
        _id : null,
        slug : "",
        username : "",
        profile : {
            gender : 0
        }
    }
};

export default ShareProfile;